import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col
} from 'reactstrap';
import LabelInput from '@src/components/LabelInput/LabelInput';
import { required, maxLength } from '@src/validation';
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import Select from 'react-select';
import moment from 'moment';
import PolicyCoverages from './PolicyCoverages/PolicyCoverages';

const fieldValidator = {
  number: [required, value => maxLength(value, 64)],
  carrier_id: [required],
  start_date: [required],
  end_date: [required]
};
class PolicyModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};

    Object.keys(fieldValidator).forEach(key => {
      fields[key] = {
        value:
          props.entity[key] !== undefined && props.entity[key] !== null
            ? key === 'start_date' || key === 'end_date'
              ? moment(props.entity[key] * 1000)
              : props.entity[key]
            : key === 'start_date' || key === 'end_date'
            ? null
            : '',
        visited: false,
        error: false
      };
    });

    const policyTypes = [];
    const policyCoverages = [];
    if (props.entity.carrier_id !== undefined) {
      const index = props.carriers.findIndex(carrier => {
        return carrier.id === props.entity.carrier.id;
      });

      fields.carrier_id.value = {
        value: props.entity.carrier.id,
        label: props.entity.carrier.name,
        object: props.carriers[index]
      };

      props.carriers[index].policy_types.map(item => {
        policyTypes.push(item);
        return false;
      });

      props.entity.policy_coverages.map(item => {
        policyCoverages.push({
          policy_type_id: {
            value: item.policy_type_id,
            visited: false,
            error: false
          },
          maximum: { value: item.maximum, visited: false, error: false },
          deductible: { value: item.deductible, visited: false, error: false },
          hired: {
            value: item.hired === 1,
            visited: false,
            error: false
          },
          non_owned: {
            value: item.non_owned === 1,
            visited: false,
            error: false
          },
          garage_keepers: {
            value: item.garage_keepers === 1,
            visited: false,
            error: false
          },
          scheduled: {
            value: item.scheduled === 1,
            visited: false,
            error: false
          },
          claims_made: {
            value: item.claims_made === 1,
            visited: false,
            error: false
          },
          occurrence: {
            value: item.occurrence === 1,
            visited: false,
            error: false
          }
        });
        return false;
      });
    }

    this.state = {
      ...fields,
      startDateFocused: false,
      endDateFocused: false,
      policyCoverages: policyCoverages,
      policyTypes: policyTypes
    };
  }

  updateCoverage = (value, name, index) => {
    const policies = JSON.parse(JSON.stringify(this.state.policyCoverages));
    policies[index][name].value = value;
    const validationMsg = name === 'maximum' ? required(value) : undefined;
    policies[index][name].visited = true;
    if (validationMsg !== undefined) {
      policies[index][name].error = validationMsg;
    } else {
      policies[index][name].error = false;
    }
    if (name === 'policy_type_id') {
      const optionPolicyList = {};
      this.state.policyTypes.map((item, key) => {
        optionPolicyList[item.id] = item.name;
        return false;
      });
      if (optionPolicyList[value] === 'Auto Liability') {
        policies[index].hired.value = true;
        policies[index].non_owned.value = true;
        policies[index].garage_keepers.value = false;
        policies[index].scheduled.value = false;
        policies[index].claims_made.value = false;
        policies[index].occurrence.value = false;
      } else if (optionPolicyList[value] === 'Directors & Officers Liability') {
        policies[index].hired.value = false;
        policies[index].non_owned.value = false;
        policies[index].garage_keepers.value = false;
        policies[index].scheduled.value = false;
        policies[index].claims_made.value = true;
        policies[index].occurrence.value = false;
      } else {
        policies[index].hired.value = false;
        policies[index].non_owned.value = false;
        policies[index].garage_keepers.value = false;
        policies[index].scheduled.value = false;
        policies[index].claims_made.value = false;
        policies[index].occurrence.value = false;
      }
    }

    this.setState({
      policyCoverages: policies
    });
  };

  addCoverage = () => {
    const policies = JSON.parse(JSON.stringify(this.state.policyCoverages));
    policies.push({
      policy_type_id: {
        value: this.state.policyTypes[0].id,
        visited: false,
        error: false
      },
      maximum: { value: '', visited: false, error: false },
      deductible: { value: '', visited: false, error: false },
      hired: {
        value: this.state.policyTypes[0].name === 'Auto Liability',
        visited: false,
        error: false
      },
      non_owned: {
        value: this.state.policyTypes[0].name === 'Auto Liability',
        visited: false,
        error: false
      },
      garage_keepers: { value: false, visited: false, error: false },
      scheduled: { value: false, visited: false, error: false },
      claims_made: {
        value:
          this.state.policyTypes[0].name === 'Directors & Officers Liability',
        visited: false,
        error: false
      },
      occurrence: { value: false, visited: false, error: false }
    });
    this.setState({
      policyCoverages: policies
    });
  };

  removeCoverage = index => {
    const policies = JSON.parse(JSON.stringify(this.state.policyCoverages));
    policies.splice(index, 1);
    this.setState({
      policyCoverages: policies
    });
  };

  updateForm = (event, name) => {
    const inputData = {
      value:
        event !== null && event.target !== undefined
          ? event.target.value
          : event,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    const currentValue = {};
    if (name === 'start_date' && this.state.end_date.value === null) {
      currentValue[name] = inputData;
      if (inputData.error === false) {
        currentValue.end_date = {
          value: moment(event).add(1, 'year'),
          visited: true,
          error: false
        };
      }

      this.setState(currentValue);
    } else if (name === 'carrier_id') {
      this.setState({
        [name]: inputData,
        policyTypes: event.object.policy_types,
        policyCoverages: [
          {
            policy_type_id: {
              value: event.object.policy_types[0].id,
              visited: false,
              error: false
            },
            maximum: { value: '', visited: false, error: false },
            deductible: { value: '', visited: false, error: false },
            hired: {
              value: event.object.policy_types[0].name === 'Auto Liability',
              visited: false,
              error: false
            },
            non_owned: {
              value: event.object.policy_types[0].name === 'Auto Liability',
              visited: false,
              error: false
            },
            garage_keepers: { value: false, visited: false, error: false },
            scheduled: { value: false, visited: false, error: false },
            claims_made: {
              value:
                event.object.policy_types[0].name ===
                'Directors & Officers Liability',
              visited: false,
              error: false
            },
            occurrence: { value: false, visited: false, error: false }
          }
        ]
      });
    } else {
      this.setState({
        [name]: inputData
      });
    }
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(fieldValidator).forEach(key => {
      postData[key] = formData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        const validationMsg = fieldValidator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });

    formData.start_date.value =
      formData.start_date.value !== null
        ? moment(formData.start_date.value)
        : null;
    formData.end_date.value =
      formData.end_date.value !== null ? moment(formData.end_date.value) : null;

    this.setState({ ...formData });

    if (isValid) {
      this.props.savePolicy({
        number: this.state.number.value,
        carrier_id: this.state.carrier_id.value.value,
        start_date: this.state.start_date.value.unix(),
        end_date: this.state.end_date.value.unix(),
        policy_coverages: this.state.policyCoverages.map(item => {
          return {
            policy_type_id: item.policy_type_id.value,
            maximum: item.maximum.value,
            deductible: item.deductible.value,
            hired: item.hired.value ? 1 : 0,
            non_owned: item.non_owned.value ? 1 : 0,
            garage_keepers: item.garage_keepers.value ? 1 : 0,
            scheduled: item.scheduled.value ? 1 : 0,
            claims_made: item.claims_made.value ? 1 : 0,
            occurrence: item.occurrence.value ? 1 : 0
          };
        })
      });
    }
    return false;
  };

  render = () => {
    const carrierOptions = [];
    this.props.carriers.map(item => {
      carrierOptions.push({
        value: item.id,
        label: item.name,
        object: item
      });

      return false;
    });

    const optionPolicyTypes = [];
    const optionPolicyList = {};
    this.state.policyTypes.map((item, key) => {
      optionPolicyTypes.push(
        <option key={key} value={item.id}>
          {item.name}
        </option>
      );
      optionPolicyList[item.id] = item.name;
      return false;
    });

    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
        size={'lg'}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {this.props.entity.id !== undefined
              ? 'Edit Policy'
              : 'Create New Policy'}
          </ModalHeader>
          <div className={'position-relative'}>
            <ModalBody className={'p-4'}>
              <Row>
                <Col xs={12}>
                  <div className={'form-group'}>
                    <div
                      className={
                        this.state.carrier_id.error ? 'is-invalid' : ''
                      }
                    >
                      <label className={'font-weight-bold'}>Carrier *</label>
                      <Select
                        value={this.state.carrier_id.value}
                        options={carrierOptions}
                        onChange={event => this.updateForm(event, 'carrier_id')}
                        placeholder={'Type to search...'}
                        isDisabled={this.props.entity.id !== undefined}
                      />
                    </div>
                    {this.state.carrier_id.error && (
                      <span className={'error'}>
                        {this.state.carrier_id.error}
                      </span>
                    )}
                  </div>
                </Col>
                <Col xs={12}>
                  <LabelInput
                    name={'Policy Number'}
                    type={'text'}
                    required={true}
                    {...this.state.number}
                    onChange={event => this.updateForm(event, 'number')}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={6}>
                  <div className={'form-group'}>
                    <label className={'font-weight-bold'}>Start Date *</label>
                    <div
                      className={
                        this.state.start_date.error ? 'is-invalid' : ''
                      }
                    >
                      <SingleDatePicker
                        date={this.state.start_date.value} // momentPropTypes.momentObj or null
                        onDateChange={startDate =>
                          this.updateForm(startDate, 'start_date')
                        } // PropTypes.func.isRequired
                        focused={this.state.startDateFocused} // PropTypes.bool
                        block={true}
                        isOutsideRange={() => false}
                        onFocusChange={({ focused }) =>
                          this.setState({ startDateFocused: focused })
                        } // PropTypes.func.isRequired
                        id="policy-start-date" // PropTypes.string.isRequired,
                      />
                    </div>
                    {this.state.start_date.error && (
                      <span className={'error'}>
                        {this.state.start_date.error}
                      </span>
                    )}
                  </div>
                </Col>
                <Col xs={6}>
                  <div className={'form-group'}>
                    <label className={'font-weight-bold'}>End Date *</label>
                    <div
                      className={this.state.end_date.error ? 'is-invalid' : ''}
                    >
                      <SingleDatePicker
                        date={this.state.end_date.value} // momentPropTypes.momentObj or null
                        onDateChange={endDate =>
                          this.updateForm(endDate, 'end_date')
                        } // PropTypes.func.isRequired
                        focused={this.state.endDateFocused} // PropTypes.bool
                        block={true}
                        isOutsideRange={() => false}
                        onFocusChange={({ focused }) =>
                          this.setState({ endDateFocused: focused })
                        } // PropTypes.func.isRequired
                        id="policy-end-date" // PropTypes.string.isRequired,
                      />
                    </div>
                    {this.state.end_date.error && (
                      <span className={'error'}>
                        {this.state.end_date.error}
                      </span>
                    )}
                  </div>
                </Col>
              </Row>
              {this.state.policyCoverages.map((item, index) => {
                return (
                  <PolicyCoverages
                    key={`policy-coverages-${index}`}
                    item={item}
                    index={index}
                    optionPolicyTypes={optionPolicyTypes}
                    optionPolicyList={optionPolicyList}
                    updateCoverage={(value, name) =>
                      this.updateCoverage(value, name, index)
                    }
                    onRemove={() => this.removeCoverage(index)}
                  />
                );
              })}
              {this.state.policyCoverages.length > 0 && (
                <Button
                  color={'secondary'}
                  type={'button'}
                  size={'sm'}
                  onClick={this.addCoverage}
                >
                  Add More Coverage
                </Button>
              )}
            </ModalBody>
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                Save
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}

export default PolicyModal;
